import React from 'react';
import { styled } from 'styled-components';
import blurryBackground from '../../Wizard/blurryBackground.jpg';

import HudLogo from '../assets/HudLogo.svg?react';
import { Button } from '../../Button/Button';
import { themeColor } from '../../theme/colors';
import { lgRegular, xxlRegular, xxsLight } from '../../theme/typography';
import {
  DomainValidationErrorDetails,
  DomainValidationErrorCode,
} from '../assets/errorCodes';

export default function GeneralErrorPage() {
  const queryParams = new URLSearchParams(location.search);

  // Extract error information from query parameters
  const errorMessage = queryParams.get('error') || '';
  const displayError =
    DomainValidationErrorDetails[errorMessage as DomainValidationErrorCode] ||
    DomainValidationErrorDetails[DomainValidationErrorCode.UNKNOWN_ERROR];

  return (
    <PageContainer>
      <GradientBorderBox>
        <HudLogo width="75px" />
        <Title>{displayError.errorMessage}</Title>
        <Subtitle>{displayError.extraInfo}</Subtitle>
        <PaddedButton
          variant={'glow'}
          className="signUp"
          onClick={() => {
            window.location.href = '/';
          }}
        >
          Back to Sign-up
        </PaddedButton>

        <Note>
          Have questions? <a href="https://docs.hud.io">contact us</a> - we're happy to
          help
        </Note>
      </GradientBorderBox>
    </PageContainer>
  );
}

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;

  background-image: url(${blurryBackground});
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  background-color: #111214; // hardcoded to match the background color of the image
  backdrop-filter: none;
`;

const GradientBorderBox = styled.div`
  border: 1px solid transparent;
  border-radius: 12px;
  background:
    /* Inner background color - match the page background or desired inner color */
    linear-gradient(${themeColor('backgroundDark')}, ${themeColor('backgroundDark')})
      padding-box,
    /* Gradient for the border */ linear-gradient(-30deg, #b65aff, #0ffee6) border-box;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;

  padding: 40px 32px;

  width: 100%;
  max-width: 600px;

  color: ${themeColor('textPrimary')};
`;

const PaddedButton = styled(Button)`
  padding: 8px 20px;
  min-width: 200px;
  justify-content: center;
`;

const Title = styled.div`
  ${xxlRegular};
  font-size: 28px;
`;

const Subtitle = styled.div`
  ${lgRegular};
  text-align: center;
`;

const Note = styled.div`
  ${xxsLight};
  color: ${themeColor('textSecondary')};

  & a {
    color: ${themeColor('textSecondary')};
  }
`;
